import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DiaryForm } from "../../../../../core/models/trial-diary-form/diary-form.model";
import { ConfirmActionModalComponent } from "../../../../../shared/confirm-action-modal/confirm-action-modal.component";
import { BaseComponent } from "../../../../../shared/base-component";
import { DiaryFormRule } from "../../../../../core/models/trial-diary-form/diary-form-rule.model";

@Component({
  selector: 'app-trial-diary-rules',
  templateUrl: './trial-diary-rules.component.html',
  styleUrl: './trial-diary-rules.component.scss'
})
export class TrialDiaryRulesComponent extends BaseComponent {
  @ViewChild('confirmRemoveRule') confirmRemoveRule: ConfirmActionModalComponent;

  @Output() editRule = new EventEmitter<DiaryFormRule>();
  @Output() ruleRemoved = new EventEmitter();

  @Input() diaryForm: DiaryForm;

  onRemoveRule(index: number) {
    this.confirmRemoveRule.showConfirmation(index.toString(), 'Remove Rule?', 'Are you sure you want to remove this rule?<br>The action cannot be undone', 'Yes, Remove')
  }

  onConfirmRemoveRule(index: string) {
    this.diaryForm.removeRuleAt(+index);
    this.ruleRemoved.emit();
  }
}
